import React from 'react';
import PropTypes from 'prop-types';

import Graphics from './components/Graphics';

import './style.scss';

export class TipBox extends React.Component {

  componentWillMount(){
    this.props.createTipBox({
      props: this.props.defaultProps
    })
  }

  toggleOpen = () => {
    this.props.tipBoxOpen(
      {
        id: this.props.id,
        open: !this.props.open
      }
    );
  }

  render() {
    return (
      <ul>
        <li
          draggable
          onClick={this.toggleOpen}
          onKeyDown={ (e)=>{if(e.keyCode === 13 || e.keyCode === 32) this.toggleOpen(e)} }
          tabIndex={0}
          id={this.props.type+"_TipBox_"+this.props.id}
          className={'TipBox draggable dropTarget'+((this.props.open)?' open':'')}
          style={{ transform: "translate3d(0px, 0px, 0px) rotateZ(0deg)" }}>
          <p aria-hidden="true" className="label">{this.props.type+" Tips"}</p>
          <Graphics
            id={this.props.id}
            type={this.props.type}
            open={this.props.open}
          />
        </li>
      </ul>
    )
  }
}

TipBox.propTypes = {
  createTipBox: PropTypes.func,
};

TipBox.defaultProps = {
};
